export default "__VITE_ASSET__Dc3eOPdX__"